<template>
    <div class="field_wrapper px_10 py_14 my_4 mt_22">
        <div class="dropdown_input_group">
            <MultiselectDropdown
                :label="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.BODY.TYPE.LABEL')"
                classNameLabel="llm_dropdown"
            >
                <multiselect
                    class="column small-12"
                    v-model="property.type"
                    :options="bodyDataTypes"
                    :multiple="false"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :hide-selected="true"
                    :placeholder="'Select'"
                    track-by="value"
                    label="label"
                    :selectLabel="''"
                    @select="onBodyDataTypeSelect"
                />
                <!-- what will happen if select object (not array) -->
            </MultiselectDropdown>
            <InputField
                v-model="property.id"
                :label="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.BODY.IDENTIFIER.LABEL')"
                :placeholder="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.BODY.IDENTIFIER.PLACEHOLDER')"
                type="text"
                :error="error && error.id && error.id._errors ? $t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.BODY.IDENTIFIER.ERROR') : ''"
            />
        </div>
            <!-- <pre>{{property}}</pre> -->
        <CheckboxInput
            v-model="property.required"
            :classNameWrapper="'param_check_label'"
            :label="'Required'"
            @onToggle="property.required = !property.required"
        />

        <!-- <InputField
             v-if="property.type && ['object','array'].includes(property.type.value)"
            v-model="property.description"
            :label="'Description'"
            type="textarea"
            class="msg_textarea"
        /> -->



        <MultiselectDropdown
            v-if="property.type && !['object','array'].includes(property.type.value)"
            :label="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.BODY.VALUE_TYPE.LABEL')"
            classNameLabel="llm_dropdown"
        >
            <multiselect
                class="column small-12"
                v-model="property.value_type"
                :options="propertyValueTypes"
                :multiple="false"
                :close-on-select="true"
                :clear-on-select="false"
                :hide-selected="true"
                :placeholder="'Select'"
                track-by="value"
                label="label"
                :selectLabel="''"
                @select="onSelectValueType"
            />
                <!-- @select="item.bodyValue = null" -->
        </MultiselectDropdown>

        <div  v-if="property.type && !['object','array'].includes(property.type.value)">
            <!-- value type -->
            <InputField
                v-if="property.value_type.value === 'llmPrompt'"
                v-model="property.description"
                :label="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.BODY.DESCRIPTION.LABEL')"
                :placeholder="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.BODY.DESCRIPTION.PLACEHOLDER')"
                type="textarea"
                class="msg_textarea"
                :error="error && error.description && error.description._errors ? $t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.BODY.DESCRIPTION.ERROR') : ''"
            />
            <!-- <DynamicVariablePiker
                v-if="property.value_type.value === 'dynamicVariable'"
                :item="property"
                :options="agentVariables"
            /> -->
            <MultiselectDropdown
                v-if="property.value_type.value === 'dynamicVariable'"
                :label="'Variable Name'"
                classNameLabel="llm_dropdown"
            >
                <multiselect
                    v-model="property.dynamic_variable"
                    class="column small-12"
                    :options="agentVariables"
                    :multiple="false"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :hide-selected="true"
                    :placeholder="'Select'"
                    track-by="name"
                    label="name"
                    :selectLabel="''"
                />
            </MultiselectDropdown>
            <InputField
                v-if="property.value_type.value === 'constantVariable'"
                v-model="property.constant_value"
                :label="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.BODY.CONSTANT_VALUE.LABEL')"
                :placeholder="$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.BODY.CONSTANT_VALUE.PLACEHOLDER')"
                type="textarea"
                class="msg_textarea"
                :error="error && error.constant_value && error.constant_value._errors ? $t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.BODY.CONSTANT_VALUE.ERROR') : ''"
            />
        </div>

        <div v-if="property.type.value === 'object' && property.properties">
            <label>
                {{$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.BODY.PROPERTIES.LABEL')}}
            </label>
            <div class="bg-light px_12 py_12" style="border-radius:8px;">
                <BodyNestedProprty
                    v-for="(propertyEl,indexEl) in property.properties"
                    :property="propertyEl"
                    :bodyDataTypes="bodyDataTypes"
                    :key="propertyEl.key || indexEl"
                    :propertyValueTypes="propertyValueTypes"
                    :variableList="variableList"
                    :index="indexEl"
                    :propertyList="property.properties"
                    :agentVariables="agentVariables"
                    :error="error && error.properties ? error.properties[indexEl] : {}"
                />
                <div class="add_body_property_btn py_20">
                    <woot-button
                        variant="smooth"
                        color-scheme="primary"
                        size="small"
                        @click="addBodyProperty"
                    >{{$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.BODY.PROPERTIES.ADD_BUTTON')}}</woot-button>
                </div>
            </div>
        </div>

        <div v-if="property.type.value === 'array' && property.items">
            <!-- separate recursive item componnet -->
            <label>
                {{$t('CAMPAIGN.LLM_CHATBOT.TOOL_ADD.BODY.ITEM.LABEL')}}
            </label>
            <div class="bg-light px_12 py_12" style="border-radius:8px;">
                <BodyArrayItem
                    :items="property.items"
                    :bodyDataTypes="bodyDataTypes"
                    :propertyValueTypes="propertyValueTypes"
                    :variableList="variableList"
                    :agentVariables="agentVariables"
                    :error="error && error.items ? error.items : {}"
                />

            </div>
        </div>

        <!-- delete btn  -->
        <div>
            <woot-button
                style="margin-left:auto; display:block;"
                variant="smooth"
                color-scheme="primary"
                size="small"
                @click="deletePropertyByIdx(index)"
            >Delete</woot-button>
        </div>


    </div>
</template>

<script>
import MultiselectDropdown from 'components/ui/inputs/MultiselectDropdown.vue';
import InputSlot from 'components/ui/inputs/MultiselectDropdown.vue'; // use as input slot
import InputField from 'components/ui/inputs/InputField.vue';
import InputCard from "components/ui/inputs/InputCard.vue";
import SliderRangeInput from "components/ui/inputs/SliderRangeInput.vue";
import CheckboxInput from "components/ui/inputs/CheckboxInput.vue";
import BodyArrayItem from "./BodyArrayItem.vue"
import DynamicVariablePiker from "./toolUI/DynamicVariablePiker.vue"

// 🔁 import itself to register for recursion
// import BodyNestedProprty from './BodyNestedProperty.vue';

export default {
    name:"BodyNestedProprty",
    components: {
        MultiselectDropdown,
        InputField,
        InputCard,
        SliderRangeInput,
        InputSlot,
        CheckboxInput,
        BodyArrayItem,
        // BodyNestedProprty,
        DynamicVariablePiker,
    },
    props:{
        property:{
            type: Object
        },
        propertyList:{
            type: Array
        },
        index:{
            type: Number,
        },
        bodyDataTypes:{
            type: Array,
            default: ()=>[],
        },
        propertyValueTypes:{
            type: Array,
            default: ()=>[],
        },
        variableList:{
            type: Array,
            default: ()=>[],
        },
        error: {
            type: Object,
            default: () => ({}),
        },
        agentVariables:{
            type: Array,
            default: ()=>[],
        },
    },
    methods:{
        onBodyDataTypeSelect(item){
            if (item.value === 'array') {
            this.property.required = false;

            // Use $set to make 'items' reactive
            this.$set(this.property, 'items', {
                type: this.bodyDataTypes[3],
                description: "",
                constant_value: "",
                dynamic_variable: { name: "", value: "" },
            });

            // Also remove properties if they exist (optional cleanup)
            if (this.property.properties) {
            this.$delete(this.property, 'properties');
            }

        } else if (item.value === 'object') {
            this.property.required = false;

            // Use $set to make 'properties' reactive
            this.$set(this.property, 'properties', [
            {
                id: "",
                type: this.bodyDataTypes[3],
                required: true,
                description: "",
                constant_value: "",
                dynamic_variable: { name: "", value: "" },
                value_type: this.propertyValueTypes[0],
            }
            ]);

            // Also remove items if it exists (optional cleanup)
            if (this.property.items) {
            this.$delete(this.property, 'items');
            }

        } else {
            // Handle other value types (e.g., string, number, etc.)
            if (this.property.value_type?.value === "llmPrompt") {
            this.property.required = true;
            }

            // Optional: remove both 'items' and 'properties' if switching to primitive type
            if (this.property.items) {
            this.$delete(this.property, 'items');
            }
            if (this.property.properties) {
            this.$delete(this.property, 'properties');
            }
        }
            /*
            if (item.value === 'array') {
                this.property.required = false;
                // push or add items
                this.property.items={
                    type: this.bodyDataTypes[3],
                    description: "",
                    constant_value: "",
                    dynamic_variable: {name:"",value:""},
                }
            }else if (item.value === 'object') {
                this.property.required = false;
                // append properties
                this.property.properties = [
                    {
                        id:"",
                        type: this.bodyDataTypes[3],
                        required: true,
                        description: "",
                        constant_value: "",
                        dynamic_variable: {name:"",value:""},
                        value_type: this.propertyValueTypes[0],
                    },
                ];
            }else{
                // if value type is llmPrompt
                if (this.property.value_type?.value === "llmPrompt") {
                    this.property.required = true;
                }
            }
            */
        },
        deletePropertyByIdx(index){
            this.propertyList?.splice(index, 1);
        },
        addBodyProperty(){
            if (!Array.isArray(this.property.properties)) {
                this.$set(this.property, 'properties', []);
            }

            const newProperty = {
                key: Date.now(),
                id: "",
                type: this.bodyDataTypes[3],
                description: "",
                required: true,
                dynamic_variable: {name:"",value:""},
                constant_value: "",
                // llm_description: "",
                value_type: this.propertyValueTypes[0] || null,
            };

            this.property.properties.push(newProperty);

            // Force Vue to update via object reassignment (hacky, but reliable in Vue 2)
            this.$set(this.property, 'properties', [...this.property.properties]);
        },


        onSelectValueType(item){
            if (item.value === "llmPrompt") {
                this.property.required = true;
            }else{
                this.property.required = false;
            }
        },

    },
}
</script>


<style lang="scss" scoped>
@import '~dashboard/assets/scss/widgets/_fonts.scss';
.field_wrapper{
    background: #fff;
}
.dropdown_input_group{
    display: grid;
    grid-template-columns: 120px 1fr;
    gap: 1rem;
}

.add_body_property_btn{
    display: flex;
    justify-items: center;
    justify-content: center;
}

.variable_input_group{
    display: grid;
    grid-template-columns: 150px 1fr 50px;
    gap: 10px;
}
</style>